
<div class="container">
  <h1 class="mainHeader">
    Kontakt
  </h1>

  <div class="contact">
    <p>Skontaktuj się z nami, aby uzyskać więcej informacji o produktach:<br>
      Centrum Konsumenckie L’Oréal Polska, ul. Grzybowska 62, 00-844 Warszawa</p>
      <p>tel. 22 33 58 800</p>
      <p>pon.-pt. 9:00-17:00</p>
  </div>


  <div class="iframe">
    <iframe id="WebformLOreal"
    width="100%"
  height="1300"
  frameborder="0"
  scrolling="no"
    src="https://loreal-consumer1.secure.force.com/Webform?Brand=L%27Oreal%20Professionnel&Country=Poland">
</iframe>
  </div>



</div>
